<template>
  <AppHeader />
  <router-view />
</template>

<script setup lang="ts">
import AppHeader from '@/components/_common/AppHeader.vue';
</script>
